import { IFakeInputs, } from '../new-application/new-application-form';
import { ILists, IOwners } from '../../interfaces/merchant';
import { TFunction } from 'react-i18next';
import { OWNER_FORM_FIELDS, OWNER_FORM_FIELDS_NAMES } from './owner-form';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';
import { isUSCountry } from '../../utils/utilities';

interface IProps {
	t: TFunction;
	formik?: any
	lists?: ILists
}

export const OWNER_CONTACT_INPUTS = ({ t, lists }: IProps): IFormInputProps[] => [
	{
		key: OWNER_FORM_FIELDS.FIRST_NAME,
		fieldName: OWNER_FORM_FIELDS.FIRST_NAME,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(OWNER_FORM_FIELDS_NAMES.FIRST_NAME)}`,
		label: t(OWNER_FORM_FIELDS_NAMES.FIRST_NAME),
		inputType: InputType.Text,
		required: true,
		additionalClasses: 'col-md-4'
	},
	{
		key: OWNER_FORM_FIELDS.LAST_NAME,
		fieldName: OWNER_FORM_FIELDS.LAST_NAME,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(OWNER_FORM_FIELDS_NAMES.LAST_NAME)}`,
		label: t(OWNER_FORM_FIELDS_NAMES.LAST_NAME),
		inputType: InputType.Text,
		required: true,
		additionalClasses: 'col-md-4'
	},
	{
		key: OWNER_FORM_FIELDS.BIRTH_DATE,
		fieldName: OWNER_FORM_FIELDS.BIRTH_DATE,
		placeholder: t(OWNER_FORM_FIELDS_NAMES.BIRTH_DATE),
		label: t(OWNER_FORM_FIELDS_NAMES.BIRTH_DATE),
		inputType: InputType.Date,
		additionalClasses: 'col-md-4'
	},
	{
		key: OWNER_FORM_FIELDS.EMAIL,
		fieldName: OWNER_FORM_FIELDS.EMAIL,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(OWNER_FORM_FIELDS_NAMES.EMAIL)}`,
		label: t(OWNER_FORM_FIELDS_NAMES.EMAIL),
		inputType: InputType.Text,
		required: true,
		additionalClasses: 'col-md-4'
	},
	{
		key: OWNER_FORM_FIELDS.PHONE,
		fieldName: OWNER_FORM_FIELDS.PHONE,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(OWNER_FORM_FIELDS_NAMES.PHONE)}`,
		label: t(OWNER_FORM_FIELDS_NAMES.PHONE),
		inputType: InputType.Phone,
		defaultCountry: 'US',
		required: true,
		additionalClasses: 'number-input-zip col-md-4',
	},
	{
		key: OWNER_FORM_FIELDS.PERCENTAGE,
		fieldName: OWNER_FORM_FIELDS.PERCENTAGE,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(OWNER_FORM_FIELDS_NAMES.PERCENTAGE)}`,
		label: t(OWNER_FORM_FIELDS_NAMES.PERCENTAGE),
		inputType: InputType.Number,
		required: true,
		additionalClasses: 'col-md-4',
	},
	{
		key: OWNER_FORM_FIELDS.ID_FORM,
		fieldName: OWNER_FORM_FIELDS.ID_FORM,
		placeholder: t(OWNER_FORM_FIELDS_NAMES.ID_FORM),
		label: t(OWNER_FORM_FIELDS_NAMES.ID_FORM),
		inputType: InputType.Select,
		data: lists?.individualFormOfID,
		searchable: false,
		additionalClasses: 'col-md-4',
	},
	{
		key: OWNER_FORM_FIELDS.ID,
		fieldName: OWNER_FORM_FIELDS.ID,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(OWNER_FORM_FIELDS_NAMES.ID)}`,
		label: t(OWNER_FORM_FIELDS_NAMES.ID),
		inputType: InputType.Text,
		additionalClasses: 'col-md-4',
	},
];

export const OWNER_ADDRESS_INPUTS = ({ t, lists, formik }: IProps): IFormInputProps[] => [
	// {
	// 	key: OWNER_FORM_FIELDS.TITLE,
	// 	fieldName: OWNER_FORM_FIELDS.TITLE,
	// 	placeholder: t(OWNER_FORM_FIELDS_NAMES.TITLE),
	// 	label: t(OWNER_FORM_FIELDS_NAMES.TITLE),
	// 	inputType: InputType.Text,
	// },
	// {
	// 	key: OWNER_FORM_FIELDS.PRINCIPAL_TYPE,
	// 	fieldName: OWNER_FORM_FIELDS.PRINCIPAL_TYPE,
	// 	placeholder: t(OWNER_FORM_FIELDS_NAMES.PRINCIPAL_TYPE),
	// 	label: t(OWNER_FORM_FIELDS_NAMES.PRINCIPAL_TYPE),
	// 	inputType: InputType.Select,
	// 	data: lists?.principalTypes
	// },
	// {
	// 	key: OWNER_FORM_FIELDS.ID_FORM,
	// 	fieldName: OWNER_FORM_FIELDS.ID_FORM,
	// 	placeholder: t(OWNER_FORM_FIELDS_NAMES.ID_FORM),
	// 	label: t(OWNER_FORM_FIELDS_NAMES.ID_FORM),
	// 	inputType: InputType.Select,
	// 	data: lists?.individualFormOfID
	// },
	// {
	// 	key: OWNER_FORM_FIELDS.ID,
	// 	fieldName: OWNER_FORM_FIELDS.ID,
	// 	placeholder: t(OWNER_FORM_FIELDS_NAMES.ID),
	// 	label: t(OWNER_FORM_FIELDS_NAMES.ID),
	// 	inputType: InputType.Text,
	// },
	// {
	// 	key: OWNER_FORM_FIELDS.STATE,
	// 	fieldName: OWNER_FORM_FIELDS.STATE,
	// 	placeholder: t(OWNER_FORM_FIELDS_NAMES.STATE),
	// 	label: t(OWNER_FORM_FIELDS_NAMES.STATE),
	// 	inputType: InputType.Select,
	// 	// required: true,
	// 	data: lists.states,
	// 	placement: 'bottomEnd',
	// 	dataCy: 'state',
	// 	disabled: formik.getFieldProps(OWNER_FORM_FIELDS.COUNTRY).value !== 'USA'
	// },
	{
		key: OWNER_FORM_FIELDS.LINE_1,
		fieldName: OWNER_FORM_FIELDS.LINE_1,
		placeholder: t(OWNER_FORM_FIELDS_NAMES.LINE_1_TOOLTIP_TEXT),
		label: t(OWNER_FORM_FIELDS_NAMES.LINE_1),
		inputType: InputType.Text,
		additionalClasses: 'col-md-12',
		isLabelIcon: true,
		tooltipText: t(OWNER_FORM_FIELDS_NAMES.LINE_1_TOOLTIP_TEXT)
	},
	{
		key: OWNER_FORM_FIELDS.LINE_2,
		fieldName: OWNER_FORM_FIELDS.LINE_2,
		placeholder: t(OWNER_FORM_FIELDS_NAMES.LINE_2_TOOLTIP_TEXT),
		label: t(OWNER_FORM_FIELDS_NAMES.LINE_2),
		inputType: InputType.Text,
		additionalClasses: 'col-md-12',
		isLabelIcon: true,
		tooltipText: t(OWNER_FORM_FIELDS_NAMES.LINE_2_TOOLTIP_TEXT)
	},
	{
		key: OWNER_FORM_FIELDS.COUNTRY,
		fieldName: OWNER_FORM_FIELDS.COUNTRY,
		placeholder: t(OWNER_FORM_FIELDS_NAMES.COUNTRY),
		label: t(OWNER_FORM_FIELDS_NAMES.COUNTRY),
		inputType: InputType.Select,
		// required: true,
		// disabled: true,
		data: lists.countries,
	},
	{
		key: OWNER_FORM_FIELDS.STATE,
		fieldName: OWNER_FORM_FIELDS.STATE,
		placeholder: t(OWNER_FORM_FIELDS_NAMES.STATE),
		label: t(OWNER_FORM_FIELDS_NAMES.STATE),
		inputType: InputType.Select,
		// required: true,
		data: lists.states,
		placement: 'bottomEnd',
		dataCy: 'state',
		disabled: !isUSCountry(formik.getFieldProps(OWNER_FORM_FIELDS.COUNTRY).value)
	},
	{
		key: OWNER_FORM_FIELDS.CITY,
		fieldName: OWNER_FORM_FIELDS.CITY,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(OWNER_FORM_FIELDS_NAMES.CITY)}`,
		label: t(OWNER_FORM_FIELDS_NAMES.CITY),
		inputType: InputType.Text,
		// required: true,
	},
	{
		key: OWNER_FORM_FIELDS.ZIPCODE,
		fieldName: OWNER_FORM_FIELDS.ZIPCODE,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(OWNER_FORM_FIELDS_NAMES.ZIPCODE)}`,
		label: t(OWNER_FORM_FIELDS_NAMES.ZIPCODE),
		inputType: InputType.Text,
		// required: true,
		additionalClasses: 'number-input-zip',
	},
];

export const OWNER_ADDRESS_FAKE_INPUTS = ({ t, data }: { t: any, data: IOwners}): IFakeInputs[] => [
	{
		key: OWNER_FORM_FIELDS.TITLE,
		label: t(OWNER_FORM_FIELDS_NAMES.TITLE),
		value: data?.title
	},
	{
		key: OWNER_FORM_FIELDS.PRINCIPAL_TYPE,
		label: t(OWNER_FORM_FIELDS_NAMES.PRINCIPAL_TYPE),
		value: data?.principalType
	},
	{
		key: OWNER_FORM_FIELDS.ID,
		label: t(OWNER_FORM_FIELDS_NAMES.ID),
		value: data?.identificationNumber
	},
	{
		key: OWNER_FORM_FIELDS.ID_FORM,
		label: t(OWNER_FORM_FIELDS_NAMES.ID_FORM),
		value: data?.individualFormOfID
	},
	{
		key: OWNER_FORM_FIELDS.LINE_1,
		label: t(OWNER_FORM_FIELDS_NAMES.LINE_1),
		value: data?.address?.line1,
		fakeInputAdditionalClass: 'col-12 col-md-6'
	},
	{
		key: OWNER_FORM_FIELDS.LINE_2,
		label: t(OWNER_FORM_FIELDS_NAMES.LINE_2),
		value: data?.address?.line2,
		fakeInputAdditionalClass: 'col-12 col-md-6'
	},
	{
		key: OWNER_FORM_FIELDS.COUNTRY,
		label: t(OWNER_FORM_FIELDS_NAMES.COUNTRY),
		value: data?.address?.country
	},
	{
		key: OWNER_FORM_FIELDS.STATE,
		label: t(OWNER_FORM_FIELDS_NAMES.STATE),
		value: data?.address?.state
	},
	{
		key: OWNER_FORM_FIELDS.CITY,
		label: t(OWNER_FORM_FIELDS_NAMES.CITY),
		value: data?.address?.city
	},
	{
		key: OWNER_FORM_FIELDS.ZIPCODE,
		label: t(OWNER_FORM_FIELDS_NAMES.ZIPCODE),
		value: data?.address?.zipCode
	},
];
